<script>
import OrderList from '../OrderList'
export default {
  name: 'canceled-orders',
  extends: OrderList,
  computed: {
    tabOrder () {
      return this.$store.getters.canceledOrders
    },
    refreshMethod () {
      return 'getCanceledOrders'
    }
  },
  mounted () {
    this.$store.dispatch('getCanceledOrders')
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?d741f1ae